module.exports = __webpack_public_path__ + "img/notPr_lost.d215a783.png";